module.exports = __webpack_public_path__ + "img/about-bio-cover.1ec85047.jpg";